
            const data = {"name":"glyph/16/check","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M12.4 6 11 4.6l-4 4-2-2L3.6 8 7 11.4z\" class=\"nc-icon-wrapper\" _fill=\"#272c33\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    